module.exports = __webpack_public_path__ + "static/media/400279_01.be7d4814.png";